(function () {
	'use strict';

	angular
		.module('app.supplyChain')
		.controller('buyerWorkbench', buyerWorkbench);

	buyerWorkbench.$inject = ['$scope', '$timeout', '$rootScope', '$state', '$filter', '$translate',
		'$location', '$window', '$experiments', 'redirectParamsService', 'leanFilterService',
		'tableRenderService', 'tableService', 'navigationService', 'pageTimingService', 'storeService', 'flexColumns', 'supplyChainReportColumns', 'uploadPOModalService'
	];

	function buyerWorkbench($scope, $timeout, $rootScope, $state, $filter, $translate, $location, $window, $experiments,
			redirectParamsService, leanFilterService, tableRenderService, tableService, navigationService, pageTimingService, storeService, flexColumns, supplyChainReportColumns, uploadPOModalService) {
		var vm = this;
		var unsubscribe;
		var timingCalled = false;
		var getDataCalled = false;
		var showRowsCalled = false;
		var pinnedColumnList = [];
		var columnList = columns();

		// redirect suppliers
		if(globalConfig.user.role === 'Supplier') {
			$state.go('app.supply-chain.workbench', { reportId: undefined });
		}

		if($experiments.isEnabled('workbench')) {
			$state.go('app.my-work.summary-workbench', { reportId: undefined });
		}

		vm.variant = $state.current.url.includes('/buyer-workbench/by-supplier/') ? 'BY_SUPPLIER' : 'ALL';
		var reportSettingsName = vm.variant === 'BY_SUPPLIER' ? 'buyer-workbench/by-supplier' : 'buyer-workbench/all';
		var baseReportName = 'Workbench';

		vm.getMeta = getMeta;

		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		vm.reportName = 'Workbench';
		$scope.reportSettingsName = reportSettingsName;
		$scope.baseReportName = baseReportName;
		vm.showExcel = true;
		vm.useReactReport = true;
		vm.broadcastExcel = function() { $rootScope.$broadcast('export-excel', {columns: getExcelColumns(), doChooseColumns: true, exportFileName: reportSettingsId ? vm.reportName : undefined}); };
		// card summary - scrollable
		vm.scrollable = vm.variant === 'BY_SUPPLIER';

		var userTimingListener = $scope.$on('showRowsCalled', function () {
			showRowsCalled = true;
			submitUserTiming();
		});
		$scope.$on('$destroy', function () {
			userTimingListener();
		});

		function submitUserTiming() {
			if (getDataCalled && showRowsCalled && !timingCalled) {
				pageTimingService.submitUserTiming(baseReportName);
				timingCalled = true;
			}
		}

		uploadPOModalService.setScopes($scope, $rootScope);

		var rendererParams = {
			multiFactory: true
		};
		var extraParams = [{}];

		var defaultFilters = [];
		var filters = {};
		leanFilterService.clearFilters();
		leanFilterService.useFactoryFilter = false;

		if (globalConfig.user.role !== 'Supplier') {
			leanFilterService.useFactoryFilter = true;
			defaultFilters = [
				{ id: 'factory', values: [globalConfig.factory.id], 'isMandatory': true }
			];
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.removable = false;
			filters.multiSelectFilters = [
				siteFilter
			];
		} else { 
			defaultFilters = [
				{ id: 'factory', values: [globalConfig.factory.id], 'isMandatory': true }
			];
			filters.multiSelectFilters = [leanFilterService.filterDefinitions['Factory']];
		}
		leanFilterService.setAllFilterLists(filters);

		function getMeta() {
			return {
				reportSettingsName: reportSettingsName,
				reportSettingsId: reportSettingsId,
				reportUrl: '{0}/WorkbenchReport',
				noPaging: false,
				pageSize: 50,
				defaultSort: 'itemCode',
				defaultSortDirection: 'asc',
				defaultFilters: defaultFilters,
				rendererParams: rendererParams,
				extraParams: extraParams,
				columns: columnList,
				pinnedColumns: pinnedColumnList,
				hideSearch: false,
				footer: false,
				setColumnDefaults: true,
				excelRequest: true,
				useReportBuilderForExcel: true,
				excelReportName: 'SupplyOrder',
				searchType: 'item'
			};
		}

		var setFirstView = _.once(navigationService.setFirstView);
		if (!reportSettingsId) {
			setFirstView({'viewType': 'buyerWorkbench'}, reportSettingsName);
		}

		function getExcelColumns() {
			var newColumns = [
				'daysDisplayType'
			];
			newColumns = _.map(newColumns, function(val) {
				return {id: val};
			});
			return columns().concat(newColumns);
		}

		function columns() {
			var columns = supplyChainReportColumns.getWorkbenchReportColumns(globalConfig.user.role === 'Supplier');
			return columns;
		}

		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

	}
})();
